import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { NestApiProvider } from '../nest-api';

export interface RequestBuilderDto {
  method: string;
  methodType: string;
  payload?: any;
}

@Injectable()
export class BuilderApi {

  private _service: string = '';
  private _model: string = 'builder';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public takeCustomMenu(payload: RequestBuilderDto): Observable<any> {
    const _method: string = 'POST';
    const _func: string = 'takeCustomMenu';
    const _params: any = payload || {};
    const _urlParams: any = {};
    const _body: any = {};
    const _contentType = 'json';

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body, _contentType);
  }

  public takeAction(payload: RequestBuilderDto): Observable<any> {
    const _method: string = 'POST';
    const _func: string = 'takeAction';
    const _params: any = payload || {};
    const _urlParams: any = {};
    const _body: any = {};
    const _contentType = 'json';

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body, _contentType);
  }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/builder/builder.api.ts